import React from "react";

import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { Button, Skeleton, Stack, Typography } from "@mui/material";

export const PanelEmptyAll: React.FC = () => (
  <Stack alignItems="center" sx={{ padding: "32px 20px 24px", textAlign: "center" }}>
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "40px",
        height: "40px",
        backgroundColor: "#f6f8fc",
        borderRadius: "50%",
        color: "#92a7bc",
        marginBottom: "12px"
      }}
    >
      <BookmarkBorderIcon sx={{ fontSize: "20px" }} />
    </Stack>
    <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "#071f35", marginBottom: "8px" }}>
      No saved views yet.
    </Typography>
    <Typography sx={{ fontSize: "13px", lineHeight: 1.5, color: "#5e7a95", maxWidth: "280px" }}>
      Save one from the page you're working on to access it from anywhere.
    </Typography>
  </Stack>
);

export const PanelLoading: React.FC = () => (
  <Stack sx={{ padding: "12px 0" }}>
    <Skeleton variant="text" width={90} height={14} sx={{ margin: "8px 16px" }} />
    {[0, 1, 2].map((i) => (
      <Stack key={i} direction="row" alignItems="center" gap="8px" sx={{ padding: "8px 16px" }}>
        <Skeleton variant="text" sx={{ flex: 1, height: 14 }} />
        <Skeleton variant="circular" width={14} height={14} />
      </Stack>
    ))}
    <Skeleton variant="text" width={90} height={14} sx={{ margin: "8px 16px" }} />
    {[0, 1].map((i) => (
      <Stack key={i} direction="row" alignItems="center" gap="8px" sx={{ padding: "8px 16px" }}>
        <Skeleton variant="text" sx={{ flex: 1, height: 14 }} />
        <Skeleton variant="circular" width={14} height={14} />
      </Stack>
    ))}
  </Stack>
);

export const PanelError: React.FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <Stack alignItems="center" sx={{ padding: "20px 16px", textAlign: "center" }}>
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        backgroundColor: "#fcf8f8",
        color: "#d32f2f",
        marginBottom: "8px"
      }}
    >
      <ReportProblemOutlinedIcon sx={{ fontSize: "18px" }} />
    </Stack>
    <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "#071f35", marginBottom: "4px" }}>
      Saved views couldn't load
    </Typography>
    <Typography sx={{ fontSize: "13px", color: "#5e7a95", marginBottom: "12px" }}>
      Check your connection and try again.
    </Typography>
    <Button
      onClick={onRetry}
      variant="text"
      color="primary"
      sx={{
        textTransform: "none",
        fontSize: "13px",
        fontWeight: 500,
        padding: "6px 12px",
        borderRadius: "4px"
      }}
    >
      Retry
    </Button>
  </Stack>
);
